module.exports = {
  "checkbox": {
    "width": 48,
    "height": 48
  },
  "title-text": {
    "fontSize": 30
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/weex-vue-loader/lib/style-loader.js!./node_modules/weex-vue-loader/lib/style-rewriter.js?id=data-v-0cca5dd5!./node_modules/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-checkbox/index.vue
// module id = 25
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28